import { INewsfeedItem, ArticleStatus, ArticleType } from "./newsfeed.types"
import { Dayjs } from "dayjs"

export class Newsfeed implements INewsfeedItem {
  id?: string
  body: string
  publishDate: Dayjs
  title: string
  type?: ArticleType
  summary?: string
  author?: string
  status?: ArticleStatus
  createdAt?: Dayjs
  updatedAt?: Dayjs

  constructor(
    body: string,
    publishDate: Dayjs,
    title: string,
    type?: ArticleType,
    options?: {
      id?: string
      summary?: string
      author?: string
      status?: ArticleStatus
      createdAt?: Dayjs
      updatedAt?: Dayjs
    },
  ) {
    this.body = body
    this.publishDate = publishDate
    this.title = title
    this.type = type
    this.id = options?.id
    this.summary = options?.summary
    this.author = options?.author
    this.status = options?.status
    this.createdAt = options?.createdAt
    this.updatedAt = options?.updatedAt
  }
}
